import type { PlanLink } from "@Light/services/lightTypes";
import { Item } from "./Item";
import { BrokerTermsOfService } from "./BrokerTermsOfService";

export type DocumentListProps = {
  links: PlanLink[];
  hideBrokerTermsOfService?: boolean;
  onItemClick?: (document: string) => void;
};

export const DocumentList: React.FC<DocumentListProps> = ({
  links,
  hideBrokerTermsOfService,
  onItemClick,
}) => {
  return (
    <div className="flex flex-col gap-8">
      {links.map(({ name, short_name, url }) => (
        <Item
          key={short_name}
          title={name}
          href={url}
          onClick={() => onItemClick?.(short_name)}
        />
      ))}
      {!hideBrokerTermsOfService && <BrokerTermsOfService />}
    </div>
  );
};
